import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Add from "../../../../icons/add.svg";
import Lupa from "../../../../icons/lupa.svg";
import Delete from "../../../../icons/delete.svg";
import { Login } from '@mui/icons-material';
import { FaPlus } from "react-icons/fa";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
// import ExportarListaTecnicos from "./ExportarListaTecnicos";
import Excel from "../../../../icons/excel.svg";
import { UsuarioContext } from "../../../../providers/userContext";
import BreadCrumb from "../../../../components/navbar/Breadcrumb";
import { Box, Tooltip } from "@mui/material";
import { IoIosWarning } from "react-icons/io";
import { DataTable } from "../../../../components";
import { useLocation, useNavigate } from 'react-router-dom';
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from "../../../../functions/parametrosURL/funcionesParamsURL";
import { withRouter } from "../../../../providers/withRouter";
import { getInstalaciones, deleteInstalacion, exportarInstalacionesKae, importarFechaFactura2Kae } from "../../../../services";
import CircularProgress from "@mui/material/CircularProgress";
import { CheckCircle, XCircle, Pencil, Download } from "lucide-react"
import RealizarInstalacion from "./realizarInstalacion";
import EditarInstalacion from "./EditarInstalacion";
import { formatoFechasEs } from "../../../../functions/funciones";
import FiltrosInstalaciones from "../../../../components/filtros/filtrosInstalaciones";
import { descargarCertificadoKae } from "../../../../functions/pdfs";
import NoVisitadoKAE from "../../../../components/noVisitadoComunidadKae";
import NoVisitadoAAFF from "../../../../components/noVisitadoAAFF";

const Instalaciones = () => {
  const { t } = useTranslation('common');
  const urlPadre = window.location.pathname;
  const navigate = useNavigate();
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  const user = useContext(UsuarioContext)
  const [instalaciones, setInstalaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(true);
  const [show, setShow] = useState(false);
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedInstalacion, setSelectedInstalacion] = useState(null);
  const [editModalOpened, setEditModalOpened] = useState(false);
  const [editInstalacionId, setEditInstalacionId] = useState(null);
  const [busqueda, setBusqueda] = useState(filtrosIniciales || {});
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [exportando, setExportando] = useState(false);
  const [importando, setImportando] = useState(false);
  const fileInputRef = useRef(null);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {

      fetchData();
      localStorage.setItem("hasReloaded", "false"); 
    }
  }, [location]);
  

  const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order = order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy);

    const payload = {
      filtros,
      params: { page: offset, limit, order, orderBy },
    };
    try {
      setLoading(true);
      const response = await getInstalaciones(payload);
      const { meta, data } = response;
      setInstalaciones(data)
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
  };

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  };

  const onSubirListado = () => {
    if (importando) return;
    fileInputRef.current?.click();
  };

  const handleFileSelected = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setImportando(true);
    const toastId = toast.loading(t('excel.uploadingList'));
    try {
      const res = await importarFechaFactura2Kae(file);
      toast.update(toastId, {
        render: t('excel.uploadSuccess', { count: res?.actualizadas ?? 0 }),
        type: 'success',
        isLoading: false,
        autoClose: 4000,
      });
      setRecargar((r) => !r);
    } catch (error) {
      console.error(error);
      const errores = error?.data?.errores ?? error?.response?.data?.errores;
      if (Array.isArray(errores) && errores.length) {
        toast.dismiss(toastId);
        const escape = (s) =>
          String(s ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        const filas = errores
          .map((e) => {
            const partes = [];
            if (e.id) partes.push(`ID ${escape(e.id)}`);
            if (e.nif) partes.push(`NIF ${escape(e.nif)}`);
            const meta = partes.length ? ` (${partes.join(', ')})` : '';
            return `<li><b>Fila ${escape(e.fila)}</b>${meta}: ${escape(e.motivo)}</li>`;
          })
          .join('');
        Swal.fire({
          icon: 'error',
          title: t('excel.uploadValidationTitle'),
          html: `
            <div style="text-align: left;">
              <p style="margin: 0 0 8px 0;">${escape(t('excel.uploadValidationIntro'))}</p>
              <ul style="margin: 0; padding-left: 20px; max-height: 280px; overflow-y: auto;">${filas}</ul>
            </div>
          `,
          confirmButtonColor: '#92004D',
          confirmButtonText: 'OK',
          width: 600,
        });
      } else {
        toast.update(toastId, {
          render: t('excel.uploadError'),
          type: 'error',
          isLoading: false,
          autoClose: 5000,
        });
      }
    } finally {
      setImportando(false);
    }
  };

  const exportarExcel = async () => {
    if (exportando) return;
    setExportando(true);
    const toastId = toast.loading(t('excel.generatingExcel'));
    try {
      const data = await exportarInstalacionesKae(busqueda || {});
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const urlObj = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = urlObj;
      link.setAttribute('download', `instalaciones_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlObj);
      toast.update(toastId, {
        render: t('excel.excelSuccess'),
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t('excel.excelError'),
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      setExportando(false);
    }
  };

  const formatData = (data) => {
    console.log(data)
    return data.map((row, i) => ({
      id:row.id,
      ano: row.invoiceDate ? new Date(row.invoiceDate).getFullYear() : "",
      nif: row.propertie.nif,
      comunidad: row.propertie.razonSocial,
      aaff: row.aaff?.razonSocial || "",
      aaff_nif: row.aaff?.nif || "",
      aaffDatos: row.aaff,
      direccion: row.propertie.direccion,
      codigoPostal: row.propertie.codigoPostal,
      municipio: row.propertie.municipio || "",
      provincia: row.propertie.provincia || "",
      invoiceDate: row.invoiceDate,
      invoiceDate2: row.invoiceDate2,
      tecnico: row.technician ? row.technician.nombre + " " + row.technician.apellidos : "",
      fechaRealizada: row.fecha_instalacion ? row.fecha_instalacion : "",
      realizada: row.realizada,
      unRealized: row.unRealized,
      unRealizedDate: row.unRealizedDate,
      unRealizedObservations: row.unRealizedObservations,
      unRealizedComments: row.unRealizedComments,
      estado_id: row.estado_id,
      estadoNombre: row.stateProps?.nombre || "",
      senales: row.productos?.reduce((sum, p) => sum + (p.cantidad || 0), 0) || 0,
      productos: row.productos || [],
      senalesObligatorias: (row.productos || []).filter((p) => p.obligatorio).length,
    }));
  };

  const ESTADO_BADGE_STYLE = {
    1: { bg: "#d1fae5", color: "#065f46" },
    4: { bg: "#fee2e2", color: "#991b1b" },
    5: { bg: "#fecaca", color: "#7f1d1d" },
  };

  const comercialesRows = [

    {
      id: "ano",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.year'),
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.nif'),
    },
    {
      id: "comunidad",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.community'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        row.nif
          ? <Link to={user.rol === 'AAFF' ? `/comunidades/${row.nif}` : `/aaff/${row.aaff_nif}/comunidades/${row.nif}`}>{data}</Link>
          : data
      ),
    },
    ...((user.rol === 'ADMIN' || user.rol === 'VENT' || user.rol === 'COMM' || user.rol === 'TECH' || user.rol === 'TECH_COOR') ? [{
      id: "aaff",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.aaff'),
      noObjeto: true,
    }] : []),
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.address'),
    },
    {
      id: "codigoPostal",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.postalCode'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.province'),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.municipality'),
    },
    {
      id: "invoiceDate",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.invoiceDate'),
      overrideFunc: (data) => (data ? formatoFechasEs(data) : ""),
    },
    {
      id: "invoiceDate2",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.invoiceDate2'),
      overrideFunc: (data) => (data ? formatoFechasEs(data) : ""),
    },
    {
      id: "tecnico",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.technician'),
    },
    {
      id: "fechaRealizada",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.performedDate'),
      overrideFunc: (data) => (data ? formatoFechasEs(data) : ""),
    },
    {
      id: "senales",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.signals'),
    },
    {
      id: "senalesObligatorias",
      numeric: false,
      disablePadding: false,
      noObjeto: true,
      label: t('installations.columns.mandatory'),
      overrideFunc: (data) =>
        data > 0 ? (
          <Tooltip title={t('installations.hasMandatorySignage', { count: data })} arrow>
            <span style={{ color: "#b26a00", display: "inline-flex", alignItems: "center", gap: 4 }}>
              <IoIosWarning size={18} />
              {data}
            </span>
          </Tooltip>
        ) : null,
    },
    {
      id: "realizada",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.done'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        data ? <CheckCircle style={{color: '#009309'}} /> : <XCircle style={{color: '#e21c1c'}} />
      )
    },
    ...((user.rol === 'ADMIN' || user.rol === 'VENT') ? [{
      id: "estadoNombre",
      numeric: false,
      disablePadding: false,
      label: t('filters.state', { defaultValue: 'Estado' }),
      noObjeto: true,
      overrideFunc: (_data, row) => {
        if (!row.estadoNombre) return "";
        const style = ESTADO_BADGE_STYLE[row.estado_id] || { bg: "#f3f4f6", color: "#374151" };
        return (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "2px 10px",
              borderRadius: 8,
              fontSize: 12,
              fontWeight: 500,
              backgroundColor: style.bg,
              color: style.color,
            }}
          >
            {t(`stateNames.${row.estadoNombre}`, { defaultValue: row.estadoNombre })}
          </span>
        );
      },
    }] : []),
    {
      id: "certificado",
      numeric: false,
      disablePadding: false,
      label: t('installations.columns.certificate'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
          {row.realizada ? (
            <Tooltip title={t('installations.detail.downloadCertificate')}>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  descargarCertificadoKae({
                    tecnicoNombre: row.tecnico,
                    ubicacionFinca: [row.direccion, row.codigoPostal, row.municipio, row.provincia].filter(Boolean).join(", "),
                    lugar: row.municipio || row.provincia || "",
                    fecha: row.fechaRealizada,
                    nifPropiedad: row.nif,
                  });
                }}
                style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
              >
                <Download size={20} className="tableIcon" />
              </span>
            </Tooltip>
          ) : null}
        </div>
      )
    },
    {
      id: "acciones",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          {/* La marca de no visita KAE del AAFF prevalece sobre la de la instalacion, como en ventas CAE */}
          {/* Sin marca del AAFF, el componente muestra el no visitado de la instalacion (fallback) */}
          {!row.realizada
            ? <NoVisitadoAAFF
                key={`aaff-${row.id}`}
                aaff={row.aaffDatos}
                servicio="KAE"
                fallback={<NoVisitadoKAE key={row.id} instalacion={row} />}
              />
            : <NoVisitadoKAE key={row.id} instalacion={row} />}
          {(user.rol === 'TECH' || user.rol === 'TECH_COOR') && !row.realizada && (
            <Link
              style={{ padding: 5 }}
              className="btn"
              onClick={() => realizarInstalacion(row)}
            >
              <FaPlus />
            </Link>
          )}
          {row.realizada && (user.rol === "ADMIN" || user.rol === "VENT" || user.rol === "TECH" || user.rol === "TECH_COOR") && (
            <Pencil
              size={20}
              className="tableIcon"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setEditInstalacionId(row.id);
                setEditModalOpened(true);
              }}
            />
          )}
          {(user.rol === "ADMIN" || user.rol === "VENT") && (
            <img
              src={Delete}
              alt={t('actions.delete')}
              className="tableIcon"
              onClick={() => eliminarInstalacion(row)}
            />
          )}
        </div>
      )
    }
  ]

  const realizarInstalacion = (com) => {
    setSelectedInstalacion(com);
    setModalOpened(true);
  }

  const handleCloseModal = () => {
    setModalOpened(false);
    setSelectedInstalacion(null);
    setRecargar(!recargar);
  }

  const eliminarInstalacion = (com) => {
    console.log(com)
    let nombre = com.nombre + " " + com.apellidos;
    Swal.fire({
      title: t('installations.messages.confirmDelete'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: t('actions.cancel'),
      confirmButtonText: t('messages.yesDelete'),
    })
      .then((result) => {
        if (result.isConfirmed) {

          deleteInstalacion(com.id)
            .then((res) => {

              if (res.message === "INSTALACION_KAE_ELIMINADA") {
                toast.success(t('installations.messages.deleted'));
                setRecargar(!recargar);
              } else {
                toast.error(t('installations.messages.deleteError'));
              }
            })
            .catch((e) => {
              toast.error(t('installations.messages.deleteError'));
              console.log(e);
            });
        }
      })
      .catch((e) => {
        toast.error(t('messages.error'));
        console.log(e);
      });
  };

  return (
    <>
      <RealizarInstalacion
        instalacion={selectedInstalacion}
        opened={modalOpened}
        handleClose={handleCloseModal}
      />
      <EditarInstalacion
        instalacionId={editInstalacionId}
        opened={editModalOpened}
        handleClose={() => {
          setEditModalOpened(false);
          setEditInstalacionId(null);
        }}
        onSaved={() => {
          setEditModalOpened(false);
          setEditInstalacionId(null);
          setRecargar(!recargar);
        }}
      />
      <BreadCrumb rutas={[{path:`/instalaciones`, label: t('installations.title')}]} />
      <div className="listPage">
        <div className="gridCard">
            <div className="gridHead">
                {t('installations.title').toUpperCase()}
            </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        {(user.rol === "ADMIN" || user.rol === "VENT") &&
          <div className="contentBar">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'end', width: '100%'}}>
              <Link to="/instalaciones/nuevo">
                <div className="contentButton mx-2">
                  <img src={Add} alt={t('installations.new')} />
                </div>
              </Link>
            </div>
          </div>
        }
        <div className="contentBar">
          <div style={{ display: 'flex', flex: 1 }}>
            <FiltrosInstalaciones
              onFilter={filtrarDatos}
              clearFilter={clearFilters}
              filtrosIniciales={busqueda}
            />
          </div>
        </div>
        <div style={{ margin: "20 0", display: 'flex', gap: 10, alignItems: 'center' }}>
          <button
            className={`bigBtn ${exportando ? 'disabled' : ''}`}
            onClick={exportarExcel}
            disabled={exportando}
          >
            {!exportando ? (
              <>
                <img src={Excel} alt={t('excel.generateList')} width="30px" />
                {t('excel.generateList')}
              </>
            ) : (
              <>
                <CircularProgress style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }} />
                {t('excel.generatingList')}
              </>
            )}
          </button>
          {(user.rol === 'ADMIN' || user.rol === 'VENT') && (
            <>
              <input
                type="file"
                ref={fileInputRef}
                accept=".xlsx,.xls"
                style={{ display: 'none' }}
                onChange={handleFileSelected}
              />
              <Tooltip title={t('excel.uploadListTooltip')} arrow>
                <button
                  className={`bigBtn ${importando ? 'disabled' : ''}`}
                  onClick={onSubirListado}
                  disabled={importando}
                >
                  {!importando ? (
                    <>
                      <img src={Excel} alt={t('excel.uploadList')} width="30px" />
                      {t('excel.uploadList')}
                    </>
                  ) : (
                    <>
                      <CircularProgress style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }} />
                      {t('excel.uploadingList')}
                    </>
                  )}
                </button>
              </Tooltip>
            </>
          )}
        </div>
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comercialesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('installations.messages.noInstallations')}
                recargar={recargar}
                clicable={true}
                onClickRow={(row) => navigate(`/instalaciones/${row.id}`)}
              />
            </Box>
          </Box>
        </div>

      </div>
    </>
  );
};

export default withRouter(Instalaciones);
